export default "__VITE_ASSET__Cx7IKUXc__"